export const config = {
  apiUrl: process.env.VUE_APP_API_URL,
  pdfUrl: process.env.VUE_APP_PDF_URL,
  uploadUrl: process.env.VUE_APP_UPLOAD_URL,
  imageUrl: process.env.VUE_APP_IMAGE_URL,
  excel: process.env.VUE_APP_EXCEL,
  socketUrl: process.env.VUE_APP_SOCKET_URL,
  env: process.env.VUE_APP_ENV
}